import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BASE_URL, createAssets, createPayment } from "./Api";

export const setLocalStorage = (key, value) => {
  sessionStorage.setItem(key, value);
  // localStorage.setItem(key, value);
}
export const getLocalStorage = (key) => {
  return sessionStorage.getItem(key);
  // return localStorage.getItem(key);
}

export const para_id = (() => {
  try {
    const parent = JSON.parse(getLocalStorage("ParentCompany"));
    // return parent?.parent_company_id || null;
    return parent?.parent_company_id || "1";
  } catch (e) {
    console.error("Error parsing parent company data from localStorage:", e);
    // return null;
    return "1";
  }
})();
export const company_logo = (() => {
  try {
    const company = JSON.parse(getLocalStorage("SUB-COMPANY"));
    var logo = "/assets/images/tech_logo.webp"
    if (company?.logo) {
      logo = BASE_URL + company?.logo
    }
    return logo || null;
  } catch (e) {
    console.error("Error parsing company data from localStorage:", e);
    return null;
  }
})();

export const warehouse_id = (() => {
  try {
    const warehouse = JSON.parse(getLocalStorage("warehouse"));
    return warehouse?.id || null;
  } catch (e) {
    console.error("Error parsing warehouse data from localStorage:", e);
    return null;
  }
})();

export const warehouse = (() => {
  try {
    const warehouse = JSON.parse(getLocalStorage("warehouse"));
    return warehouse || null;
  } catch (e) {
    console.error("Error parsing warehouse data from localStorage:", e);
    return null;
  }
})();

export const shop_id = (() => {
  try {
    const shop = JSON.parse(getLocalStorage("SHOP"));
    return shop?.shop_id || null;
  } catch (e) {
    console.error("Error parsing warehouse data from localStorage:", e);
    return null;
  }
})();

export const generateRandomCode = () => {
  let code = '';
  for (let i = 0; i < 8; i++) {
    code += Math.floor(Math.random() * 9) + 1; // Generate a random number between 1 and 9
  }
  return code;
}

export const numberToWords = (num) => {
  const units = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  ];
  const teens = [
    "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen",
  ];
  const tens = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
  ];
  const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

  if (num === 0) return "Zero";

  // Handle negative numbers
  if (num < 0) return `Negative ${numberToWords(-num)}`;

  // Handle decimal numbers
  const [integerPart, decimalPart] = num.toString().split(".");

  const convert = (n) => {
    if (n < 10) return units[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) {
      return `${tens[Math.floor(n / 10)]} ${units[n % 10]}`.trim();
    }
    if (n < 1000) {
      return `${units[Math.floor(n / 100)]} Hundred ${convert(n % 100)}`.trim();
    }
    for (let i = 0; i < scales.length; i++) {
      const unit = 1000 ** (i + 1);
      if (n < unit) {
        const divisor = unit / 1000;
        return `${convert(Math.floor(n / divisor))} ${scales[i]} ${convert(n % divisor)}`.trim();
      }
    }
  };

  const integerWords = convert(parseInt(integerPart, 10));
  if (!decimalPart) return integerWords;

  const decimalWords = decimalPart
    .split("")
    .map((digit) => units[parseInt(digit, 10)])
    .join(" ");

  return `${integerWords}`;
};


// export const AmountInWords = (amount) => {
//   const riyalPart = Math.floor(amount);
//   const baisaPart = Math.round((amount - riyalPart) * 100);

//   const riyalWords = numberToWords(riyalPart);
//   const baisaWords = numberToWords(baisaPart);

//   const amountInWords = `${riyalWords} Riyal${baisaPart !== 0 ? ` and ${baisaWords} Baisa` : ""} Only.`;

//   return amountInWords;
// };

export const AmountInWords = (amount) => {
  const numAmount = Number(amount); // Ensure it's a number

  if (isNaN(numAmount)) {
    return "Invalid amount";
  }

  const riyalPart = Math.floor(numAmount);

  // Extract the decimal part as a string with 3 decimal places
  const decimalString = numAmount.toFixed(3).split('.')[1]; // always 3 digits
  const baisaPart = parseInt(decimalString, 10);

  const riyalWords = numberToWords(riyalPart);
  const baisaWords = numberToWords(baisaPart);

  const amountInWords = `${riyalWords} Rupees ${baisaPart !== 0 ? ` and ${baisaWords} Paisa` : ""} Only.`;

  return amountInWords;
};





export const handlePrint = async (REF) => {
  const content = REF.current;

  if (!content) {
    console.error("Modal content not found for printing");
    return;
  }

  try {
    const canvas = await html2canvas(content, {
      scale: 2,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    const printWindow = window.open(pdfUrl, "_blank");

    if (printWindow) {
      printWindow.print();
    } else {
      console.error("Failed to open the print window");
    }

    URL.revokeObjectURL(pdfUrl);
  } catch (error) {
    console.error("Failed to generate or print the PDF:", error);
  }
};

export const currentMonth = () => {

  const date = new Date();
  if (isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // return `${day}-${month}-${year}`;
  return `${year}-${month}`;
};

export const currentDate = () => {

  const date = new Date();
  if (isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  // return `${day}-${month}-${year}`;
  return `${year}-${month}-${day}`;
};

export const yesterdayDate = () => {
  const date = new Date();

  // Subtract 1 day
  date.setDate(date.getDate() - 1);

  if (isNaN(date)) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${year}-${month}-${day}`;
};

export const formatDate2 = (dateString) => {
  if (!dateString) return "";

  const day = dateString.split("/")[0];
  const month = dateString.split("/")[1];
  const year = dateString.split("/")[2];

  return `${year}-${month}-${day}`;
};

export const formatDate = (dateString) => {
  if (!dateString) return ""; // Handle empty or undefined date

  const date = new Date(dateString);
  if (isNaN(date)) return ""; // Ensure valid date

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const NaviGate = () => {
  //const navigate = useNavigate()
  // return (
  //   <div className="mb-2"><button className='btn py-1 btn-secondary text-small' onClick={() => navigate(-1)}>Back</button></div>
  // )
}
export const NaviGate1 = () => {
  const navigate = useNavigate();

  return (
    <div className="mb-0 text-bold">
      <i
        className="bi bi-arrow-left-circle"
        style={{
          fontSize: "36px",
          cursor: "pointer",
          color: "#012438",
        }}
        onClick={() => navigate(-1)}
      ></i>
    </div>
  )
}

export const handleImageError = (event) => {
  event.target.src = `/images/imageplaceholder.jpeg`; // Path to your default image
};

export const handleUserImageError = (event) => {
  event.target.src = '/images/add-user1.png';
};

export const getFormattedCurrentDate = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getFormattedCurrentDate2 = () => {
  const currentDate = new Date();
  console.log(currentDate);
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();

  return `${year}-${month}-${day}`;
};

export const getFormattedCurrentDateTime = () => {
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, "0");
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getCurrentMonthName = () => {
  const currentDate = new Date();
  return currentDate.toLocaleString("en-US", { month: "long" });
};

export const handleCreateAssets = async (order_no, amount, purchase_unit, in_or_out, assets_type) => {
  try {
    let payload = {
      order_no: order_no,
      amount: amount,
      date: currentDate(),
      purchase_unit: purchase_unit,
      assets_type: assets_type,
      in_or_out: in_or_out,
      status: "0",
      shop_id: shop_id,
    };

    const response = await createAssets(payload);

    if (response.data && response.data.data) {
      const assetsdata = response.data.data;
      console.log("Assestes Data", assetsdata);
    }
  } catch (error) {
    console.error("Error saving expense");
  }
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validateDates = (fromdate, todate, key1, key2, future = false) => {
  const today = new Date();
  const mfgDate = new Date(fromdate);
  const expDate = new Date(todate);

  if (future && mfgDate > today) {
    return `${key1} date cannot be in the future.`;
  }
  if (expDate <= mfgDate) {
    return `${key2} date must be grater than the ${key1} date.`;
  }
  return "";
};

export const validateDateTime = (fromDateTime, toDateTime, key1, key2) => {
  const startDateTime = new Date(fromDateTime);
  const endDateTime = new Date(toDateTime);

  if (isNaN(startDateTime) || isNaN(endDateTime)) {
    return "Invalid date format.";
  }

  if (endDateTime <= startDateTime) {
    return `${key2} must be later than ${key1}.`;
  }

  return "";
};

export const onReqCreatePayment = async (paydata, isReturn = false) => {
  const { mop, orderID, date, amount, total_amount, type, complete } = paydata;

  const mopList = mop.split(",");

  for (let method of mopList) {
    let paymentPayload = {
      orderID,
      date,
      amount: paydata[method === "1" ? "cash" : method === "2" ? "credit" : "card"],
      total_amount,
      mop: method,
      invoice: "0",
      type: type, //1- purchase, 2- sales, 3 -service, 4- purchase return, 5 -sales return
      shop_id: shop_id,
      complete: complete || 0,
      isReturn
    };

    try {
      const response = await createPayment(paymentPayload);
      if (type != 3) {
        if (type == 0) {
          await handleCreateAssets(orderID, paymentPayload.amount, method == "2" ? 2 : 1, method == "2" ? "0" : "1", "1");
        } else {
          await handleCreateAssets(orderID, paymentPayload.amount, method == "2" ? 2 : 1, method == "2" ? "1" : "0", "0");
        }
      }
      console.log(`Payment successful for MOP ${method}:`, response.data);
    } catch (error) {
      console.error(`Error processing payment for MOP ${method}:`, error);
    }
  }
};

export const Clock = () => {
  const [time, setTime] = useState(
    new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit" })
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(
        new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", })
      );
    }, 1000);

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return <span>{time}</span>;
};

export const isReadonlyRoute = (route) => {
  try {
    const user = JSON.parse(getLocalStorage("AuthUser"))?.user || null
    if (user?.role_title === 'Super Admin') return false;
    const permissions = JSON.parse(user?.menu_list || '[]');
    const matched = permissions.find((item) => item.menu === route);
    return matched ? matched.readonly === true : false;
  } catch (err) {
    console.error('Error parsing userMenus:', err);
    return false;
  }
};